module.exports = __webpack_public_path__ + "img/lets-jetty.e9328611.svg";